import feature from './feature.reducer';

export default feature;
